module.exports = __webpack_public_path__ + "media/images/game_icon/en/AB1021-45db12d76eca43b5cdd49d866c2c6bdc.png";